'use client';

import { XiaowanPage } from '@flowx/xiaowan/client';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import { Module } from '@/types/auth';

export default function XiaowanRoute() {
  return (
    <ProtectedRoute requiredModule={Module.XIAOWAN}>
      <XiaowanPage />
    </ProtectedRoute>
  );
}
